// extracted by mini-css-extract-plugin
export default {"board":"Board_board__I9Jnx"};